module.exports = __webpack_public_path__ + "img/banner4.a02f83e6.png";